<template>
  <v-app>
    <global-header v-if="userLoggedIn" />

    <v-main>
      <router-view></router-view>
      <global-eventSelectorMobile />
    </v-main>

    <global-footer v-if="userLoggedIn" />
  </v-app>
</template>

<script>
import { mapActions, mapState } from "vuex";

/* eslint-disable no-unused-vars */
export default {
  data: () => ({
    polling: null,
  }),
  computed: {
    ...mapState("app", ["userLoggedIn"]),
    ...mapState("filter", ["globalEventFilter"]),
  },
  created() {
    // Do not clear accessToken/accessUser here — report downloads and page
    // refresh need them, and Cognito remains the source of truth. Logout
    // already wipes session keys via app/logout.
  },
  watch: {
    $route(to, from) {
      document.title = to.meta.title || "Dashboard";
    },
    "globalEventFilter.EventId"(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        console.log("EventId changed: ", newVal);
        // this.fetchStallHolders(newVal);
        if (this.userLoggedIn) {
          this.updateDashboard("Initial App.Vue Dashboard Update WITH EventId");
        }
      }
    },
    userLoggedIn(newValue, oldValue) {
      if (newValue === true) {
        // Drop any leftover dashboard rows before the new user's data arrives
        this.$store.commit("dashboard/resetDashboardState");
        this.initialLogin()
          .then((response) => {
            console.log("Login Response", response);
            if (response && response.RecentlyViewed) {
              localStorage.setItem(
                "setSelectedEventId",
                response.RecentlyViewed.EventId
              );
            }
            // Always refresh dashboard for the new session (same EventId as
            // previous user would otherwise skip the EventId watcher)
            if (this.userLoggedIn) {
              this.updateDashboard("Post-login dashboard refresh");
            }
          })
          .catch((err) => {
            console.error("initialLogin failed:", err);
          });
      } else {
        this.stopDashboardPolling();
        console.log("Stopped polling - user logged out");
      }
    },
  },
  methods: {
    ...mapActions("dashboard", [
      "updateDashboard",
      "startDashboardPolling",
      "stopDashboardPolling",
    ]),
    ...mapActions("filter", ["initialLogin"]),
  },
};
</script>

<style>
#app {
  /* color: blue; */
  background-color: #272b30;
}
</style>
